// extracted by mini-css-extract-plugin
export default {"sheet":"SheetPreview-module__sheet__L7KUQ","table":"SheetPreview-module__table__AGq2O","cell":"SheetPreview-module__cell__+UTYL"};